import { Api } from 'utils';

class RatingService {
  static admin = {
    get: async (params?: any) => Api.createResponse('admin/ratings/', params),
    getLawyers: async (params?: any) =>
      Api.createResponse('admin/ratings/lawyers', params),
  };
}

export default RatingService;
